import { Injectable, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import * as moment from "moment";
import { Message, MessageService } from "primeng/api";
import { environment } from "src/environments/environment";
import { User } from ".";
import { AdministracionService } from "../administracion/administracion.service";
import { UIService } from "./services/ui.service";

/**
Objeto de control padre para todas las funcionalides-
Encapsula variables y comportamientos comunes a todo el sistema
*/
@Injectable()
export class FazilComponent {
    
    //Variables de configuración/mensajes
    appConfig = environment.settings;

    errors: Object = {};
    msgs: Message[] = [];
    
    
    //Manejo de contexto de usuario
    private _currentUser: User;
    
    //UX
    ui: UIService;
    
    //Estados de ejecución
    procesando: boolean = false;
    status: string = "";
    
    search:string = '';
    
    constructor(
        public uiService: UIService,
        public messageService: MessageService,
        public _formBuilder: FormBuilder 
   ) {

        this.ui = uiService;
        moment.locale('es');
    }

    @Input()
    set currentUser(currentUser: User) {
        this._currentUser = currentUser
    }

    get currentUser() { return this._currentUser; }
}